/**
 * Created by Andrey Popov on 24.07.2025
 */

const Merge2StatInfo = {
    _nodes: [],
    _listeners: [],

    calcUnitEnergyCost: function (unit) {
        return Math.pow(2, unit.stage);
    },

    getOrdersEnergyCost: function (orders) {
        return orders.map((orderConfig) => {
            let energyInIngredients = 0;
            orderConfig.ingredients.forEach((ingredient) => {
                energyInIngredients += Merge2StatInfo.calcUnitEnergyCost(ingredient);
            });

            return energyInIngredients;
        }).reduce((acc, val) => acc + val, 0);
    },

    toggleInfo: function () {
        this._nodes.forEach((node) => {
            node.removeFromParent();
        });
        this._nodes = [];

        this._listeners.forEach((listener) => {
            listener.clear();
        });
        this._listeners = [];

        const scene = cleverapps.Scenes.GetRunningScene();
        const isVisible = cleverapps.gameModes.merge2BalanceStats && Merge2.current;
        if (isVisible) {
            this._nodes.push(this.addFloatLevel());
            if (Merge2.current.mode === Merge2.MODE_GAME) {
                this._nodes.push(this.addOrderIndex());
                this._nodes.push(this.addLineBalances());
            }
            if (Merge2.current.mode === Merge2.MODE_META) {
                this._nodes.push(this.addStarsAmount());
                this._nodes.push(this.addRoomInfo());
            }

            const location = cleverapps.meta.getSelectedLocation();
            this._listeners.push(Merge2.current.on("changeMode", this.toggleInfo.bind(this), scene));
            this._listeners.push(location.on("changeStars", this.toggleInfo.bind(this), scene));
            this._listeners.push(location.on("nextStage", this.toggleInfo.bind(this), scene));
            this._listeners.push(cleverapps.exp.on("changeExp", this.toggleInfo.bind(this), scene));
            this._listeners.push(cleverapps.eventBus.on("mapEvent", this.toggleInfo.bind(this), scene));
        }

        this._listeners.push(cleverapps.eventBus.on("toggleGameMode:merge2BalanceStats", this.toggleInfo.bind(this), scene));
    },

    addFloatLevel: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const debugFloatLevel = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.STAT_INFO_TEXT);
        scene.addChild(debugFloatLevel);
        debugFloatLevel.setString(Math.floor((cleverapps.user.getLevel() + cleverapps.user.getExp() / cleverapps.user.getExpThreshold()) * 100) / 100);
        debugFloatLevel.setAlignment(cleverapps.styles.Merge2StatInfo.debugFloatLevel);

        return debugFloatLevel;
    },

    addOrderIndex: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const debugOrderIndex = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.STAT_INFO_TEXT);
        scene.addChild(debugOrderIndex);
        const m = Merge2.current.orderManager;
        debugOrderIndex.setString(`${m.index}`);
        debugOrderIndex.setAlignment(cleverapps.styles.Merge2StatInfo.debugOrderIndex);

        return debugOrderIndex;
    },

    addStarsAmount: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const debugStarsCount = cleverapps.UI.generateImageText("", cleverapps.styles.FONTS.STAT_INFO_TEXT);
        scene.addChild(debugStarsCount);
        const location = cleverapps.meta.getSelectedLocation();
        debugStarsCount.setString(
            `${cleverapps.meta.getSelectedLocation().stars.stars}/${location.tillEndLocationStars()}`
        );
        debugStarsCount.setAlignment(cleverapps.styles.Merge2StatInfo.debugStarsCount);

        return debugStarsCount;
    },

    addLineBalances: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const orderManager = Merge2.current.orderManager;
        const simpleAlgo = orderManager.simpleAlgorithm;
        const averages = simpleAlgo.lineBalancer.calcEMAs();
        const items = Object.keys(averages).map((line) => cleverapps.UI.generateOnlyText(`${line}: ${averages[line].toFixed(2)}`, cleverapps.styles.FONTS.STAT_INFO_TEXT));
        const debugLineBalances = new cleverapps.Layout(items, {
            direction: cleverapps.UI.VERTICAL
        });
        scene.addChild(debugLineBalances);
        debugLineBalances.setAlignment(cleverapps.styles.Merge2StatInfo.debugLineBalances);

        return debugLineBalances;
    },

    addRoomInfo: function () {
        const scene = cleverapps.Scenes.GetRunningScene();
        const roomView = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).roomView;
        let textItems = [];

        if (roomView.getStateInfo) {
            textItems = textItems.concat(roomView.getStateInfo());
        }

        const location = cleverapps.meta.getSelectedLocation();
        textItems.push(`Fix N ${location.getCurrentStage()}`);
        textItems.push(`Fix continuous N ${location.getContinuousStage()}`);

        const statItems = new cleverapps.Layout(textItems.map((textItem) => {
            const text = cleverapps.UI.generateOnlyText(textItem, cleverapps.styles.FONTS.STAT_INFO_TEXT);
            text.setAnchorPoint(1, 0.5);
            return text;
        }), {
            direction: cleverapps.UI.VERTICAL
        });
        scene.addChild(statItems);
        statItems.setAlignment(cleverapps.styles.Merge2StatInfo.debugRoomState);

        return statItems;
    }
};

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    STAT_INFO_TEXT: {
        size: 30,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.Merge2StatInfo = {
    debugFloatLevel: {
        x: { align: "left", dx: 0 },
        y: { align: "top", dy: -120 }
    },

    debugOrderIndex: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -260 }
    },

    debugStarsCount: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -260 }
    },

    debugRoomState: {
        x: { align: "right", dx: -20 },
        y: { align: "top", dy: -310 }
    },

    debugLineBalances: {
        x: { align: "right", dx: -20 },
        y: { align: "center", dy: -40 }
    }
};

if (typeof cc === "undefined") {
    module.exports = Merge2StatInfo;
}